module.exports = __webpack_public_path__ + "static/media/carousal_1_mobile.ab6d4adc.jpg";